import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";

class SimplifiedTaskForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="title"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Select
                            {...this.props.getFieldProps("workgroup")}
                            name="workgroup"
                            component="Group"
                            storeType="local"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.workgroup}
                            label="Feladatot megoldja"
                            filter={{field: "email", operator: "not isnull"}}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Select
                            name="priority"
                            optionname="task_manager_priority"
                            objectValue={false}
                            storeType="local"
                            label="Fontosság"
                            value={this.props.values.priority}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <DateTimeInput
                            {...this.props.getFieldProps("deadline")}
                            name="deadline"
                            value={this.props.values.deadline}
                            label="Határidő"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(SimplifiedTaskForm);
